/**
 * @description i18n zh-CN
 * @author wangfupeng
 */

export default {
  tableModule: {
    modal: {
      border: '边框',
      borderWidth: '宽度',
      bgColor: '背景色',
      align: '对齐方式',
      ok: '确定',
    },
    color: {
      default: '默认颜色',
      clear: '清除背景色',
    },
    borderStyle: {
      none: '无样式',
      solid: '实线',
      dotted: '点状虚线',
      dashed: '虚线',
      double: '双线',
      groove: '凹槽边框',
      ridge: '菱形边框',
      inset: '凹边框',
      outset: '凸边框',
    },
    deleteCol: '删除列',
    deleteRow: '删除行',
    deleteTable: '删除表格',
    widthAuto: '宽度自适应',
    insertCol: '插入列',
    insertRow: '插入行',
    insertTable: '插入表格',
    header: '表头',
    mergeCell: '合并单元格',
    splitCell: '拆分单元格',
    tableProperty: '表格属性',
    cellProperty: '单元格属性',
  },
}
